module.exports = __webpack_public_path__ + "static/media/calendar-icon.8009a0b5.png";